import { LocationParams } from 'lib/componentLocation';
import { enumItems } from 'lib/enumItems';
import { serializeDate } from 'common/services/routeParams';
import { DateRange, DateRangeSelector } from './model';

// Standard utilities for parsing/serializing the DateRange enum

export function serializeDateRange(range : DateRange) {
    if (range === DateRange.AllDates) return 'alldates';
    if (range === DateRange.ThisWeek) return 'thisweek';
    if (range === DateRange.LastWeek) return 'lastweek';
    if (range === DateRange.ThisMonth) return 'thismonth';
    if (range === DateRange.LastMonth) return 'lastmonth';
    if (range === DateRange.ThisYear) return 'thisyear';
    if (range === DateRange.LastYear) return 'lastyear';
    if (range === DateRange.Custom) return 'custom';
    throw new Error('Unknown range value: ' + range);
}

const allDateRanges = [
    DateRange.AllDates,
    DateRange.ThisWeek,
    DateRange.LastWeek,
    DateRange.ThisMonth,
    DateRange.LastMonth,
    DateRange.ThisYear,
    DateRange.LastYear,
    DateRange.Custom
];

export function parseDateRange(range : string) {
    range = range.toLowerCase();
    for (let i = 0; i < allDateRanges.length; i++) {
        if (range === serializeDateRange(allDateRanges[i])) {
            return allDateRanges[i];
        }
    }
    throw new Error('Unknown range string: ' + range);
}

export function outboundDateRangeParams(m : DateRangeSelector, params : LocationParams, defaultRange: DateRange, keys : { range : string, from : string, to : string }) {
    if (m.Range() !== defaultRange) params[keys.range] = serializeDateRange(m.Range());
    if (m.Range() === DateRange.Custom) {
        params[keys.from] = serializeDate(m.FromDate());
        params[keys.to] = serializeDate(m.ToDate());
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/daterangeselector/routeParams.ts